import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

class Header {
  constructor() {
    this.body = null;
    this.container = null;
    this.header = null;
    this.controller = null;
    this.sceneSettings = null;
    this.scene = null;
    this.scrollY = 0;
    this.scrollYInitial = window.pageYOffset || document.documentElement.scrollTop;

    this.getElements();
    this.init();
  }

  getElements() {
    this.body = document.querySelector('body');
    this.container = document.querySelector('.header-container');
    this.header = document.querySelector('.header');
  }

  init() {
    this.setController();
    this.setSceneSettings();
    this.setScene();
    this.addSceneEvents();
    this.scrollHideEvent();
  }

  setController() {
    this.controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        reverse: true,
      },
    });
  }

  destroyController() {
    if (this.controller !== null) {
      this.controller = this.controller.destroy(true);
      this.controller = null;
    }
  }

  setSceneSettings() {
    this.sceneSettings = {
      triggerElement: this.container,
      duration: this.container.clientHeight,
      triggerHook: 0,
    };
  }

  setScene() {
    this.scene = new ScrollMagic.Scene(this.sceneSettings)
      // .addIndicators()
      .addTo(this.controller);
  }

  addSceneEvents() {
    this.scene.on('leave', (event) => {
      if (event.scrollDirection === 'FORWARD') {
        this.setFixed();
      }
    });
  }

  setFixed() {
    this.header.classList.add('disable-transition');

    setTimeout(() => {
      this.header.classList.remove('is-static');
    }, 10);

    setTimeout(() => {
      this.header.classList.remove('disable-transition');
    }, 100);
  }

  scrollHideEvent() {
    document.addEventListener('scroll', () => {
      const headerDisable = this.header.classList.contains('disable-hide') || this.header.classList.contains('is-static');

      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;

      if (headerDisable === false) {
        if (this.scrollY < this.scrollYInitial) {
          this.header.classList.remove('is-hidden');
          this.body.classList.remove('nav-hidden');
        } else {
          this.header.classList.add('is-hidden');
          this.body.classList.add('nav-hidden');
        }
        if (this.scrollY < this.header.clientHeight * 0.8) {
          this.header.classList.remove('is-hidden');
          this.body.classList.remove('nav-hidden');
        }
      }

      if (this.scrollY === 0) {
        this.header.classList.add('is-static');
      }

      this.scrollYInitial = this.scrollY;
    }, { passive: true });
  }
}

export const header = () => {
  new Header(); // eslint-disable-line no-new
};
